import { SxProps } from "@mui/material";

export const BORDER_RADIUSES = {
  0: "4px",
};
